import { LitElement, html } from 'lit';
import { NotificationController } from '@/controllers/NotificationController';
import { getMessage } from '@/localization.js';
import messages from './localization.json';
import { TOOLTIP_ATTR } from '@/components/tooltip/constants.js';
import { STATUS } from '@/components/notification/notification/constants.js';

export default class SotbitCopy extends LitElement {
    static properties = {
        value: { type: String },
        size: { type: String },
        messageCopied: { type: String, attribute: 'message-copied' },
    };

    constructor() {
        super();

        this.value = '';
        this.size = 's';
    }

    connectedCallback() {
        super.connectedCallback();

        if (!this.hasAttribute('TOOLTIP_ATTR')) {
            this.setAttribute(TOOLTIP_ATTR, getMessage(messages, 'copy'));
        }

        this.addEventListener('click', this._handleClick.bind(this));
    }

    handleCopySuccess() {
        NotificationController.addNotification(this.messageCopied || getMessage(messages, 'copied'), STATUS.SUCCESS);
    }

    async copyToClipboard(value) {
        try {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(value);

                this.handleCopySuccess();
                return;
            }

            const range = document.createRange();
            const hiddenNode = document.createElement('div');

            hiddenNode.textContent = value;
            hiddenNode.style.position = 'absolute';
            hiddenNode.style.width = 0;

            document.body.appendChild(hiddenNode);

            range.selectNode(hiddenNode);

            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);

            document.execCommand('copy');

            window.getSelection().removeAllRanges();

            document.body.removeChild(hiddenNode);

            this.handleCopySuccess();
        } catch {
            NotificationController.addNotification(getMessage(messages, 'copyFailed'), STATUS.ALERT);
        }
    }

    _handleClick() {
        this.copyToClipboard(this.value.trim());
    }

    render() {
        return html`
            <sotbit-icon
                part="copy"
                variant="secondary"
                icon="copy-content"
                size="${this.size}"
                pointer
                background
            ></sotbit-icon>
        `;
    }
}
